import { loadScript, removeScripts } from 'common-utils';

import { TrackingTool } from '../tracking-tool';

declare global {
  interface Window {
    _bigint?: {
      track: (l: unknown, de: unknown, da: unknown) => void;
      _oB: Array<unknown>;
    };
    cactusglobal_io?: Record<string, string>;
  }
}

export class BigInt implements TrackingTool {
  getName = () => 'bigInt';
  turnOn = async () => {
    window['_bigint'] = {
      track: function (l, de, da) {
        window._bigint?._oB.push({ l, de, da });
      },
      _oB: [],
    };

    const subdomain = /(dev|stage)[0-9]*\./gi.test(window.location.hostname)
      ? 'test1.'
      : '';

    window.cactusglobal_io = {};
    window.cactusglobal_io.endpoint = `https://${subdomain}api.cactusglobal.io/v1/`;

    const date = new Date();

    await loadScript(
      `https://${subdomain}cf.cactusglobal.io/assets/client-track.js?${date.getFullYear()}${date.getMonth()}${date.getDate()}${date.getHours()}`,
    );
  };
  turnOff = async () => {
    removeScripts(['cf.cactusglobal.io']);
    delete window._bigint;
    delete window.cactusglobal_io;
  };
}
